import api from 'features/common/transport'

import {ERROR_DEFAULT} from 'features/common/core/errors'

const deleteEmployee = async (employeeId: number) => {
    const res = await api.delete(`team/member/${employeeId}`)

    if (!res.ok) {
        throw new Error(ERROR_DEFAULT + ' ' + res.statusText)
    }
}

export default deleteEmployee
